<template>
  <div>
    <GridSyclus
      :idRecursoSistema="args.idRecursoSistema"
      title="Motivos"
      :headers="motivoHeaders"
      :customHeaders="customHeaders"
      :items="motivos"
      item-key="IdMotivo"
      :loading="loading"
      @aplicaFiltros="aplicaFiltros"
      @abreModalGridSyclus="abreModalGridSyclus"
      @changeLayoutSql="changeLayoutSql"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
    />
    <ModalCadastroMotivo 
      v-model="modalMotivo"
      :motivo="motivo"
      @motivoAdicionado="motivoAdicionado"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSyclus from '@/components/shared/GridSyclus';
import Motivo from '@/domain/motivo/Motivo';
import ModalCadastroMotivo from '@/components/motivo/ModalCadastroMotivo';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'MotivosView',
  components: {
    GridSyclus,
    ModalCadastroMotivo
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100021
      },
      motivoHeaders: [
        { text: "ID", value: "IdMotivo" },
        { text: "Descrição", value: "Descricao" },
        { text: "Status", value: "Status" },
      ],
      customHeaders: ["Status"],
      loading: false,
      modalMotivo: false,
      motivo: new Motivo()
    }
  },
  computed: {
    ...mapGetters(['user', 'motivos']),
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'fetchMotivosSql',
      'fetchLayoutsSqlUsuario',
      'deleteMotivo',
    ]),
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100021 });
      await this.fetchMotivosSql(this.args);
      this.loading = false;
    },
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    abreModalGridSyclus() {
      this.modalMotivo = true;
      this.motivo = Object.assign({}, new Motivo());
    },
    editItemSelected(payload) {
      if (payload && payload.IdMotivo) {
        this.motivo = payload;
        this.modalMotivo = true;
      } else if (payload.length) {
        this.motivo = payload[payload.length - 1];
        this.modalMotivo = true;
      } else {
        this.showNotification({ text: "Selecione um motivo para alterar.", status: 'error' });
      }
    },
    deleteItemSelected(payload) {
      if (payload.length) {
        if (confirm(`Tem certeza que deseja excluir: ${payload.length} registros?`)) {
          let promises = [];

          payload.forEach(item => {
            promises.push(this.deleteMotivo(item.IdMotivo));
          });
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os motivos: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um motivo para excluir.', status: 'error' });
      }
    },
    motivoAdicionado() {
      this.motivo = Object.assign({}, new Motivo());
    }
  },
  created() {
    changePageTitle('Motivos');
  }
}
</script>

<style>

</style>